import styled from 'styled-components';
import { StockModelCardOptionsStyled } from '../StockModelCardOptionsStyled';
import { rem } from 'polished';

export const StockModelCardOptionsStyledAC = styled(StockModelCardOptionsStyled)`
    .stockModelCard-options {
        &--heading {
            font-size: ${rem('14px')};
        }

        &--item {
            font-size: ${rem('16px')};
            margin-left: 1rem;

            &::before {
                left: -0.8rem;
            }
        }
    }
    .stockModelCard-options--tooltipItem {
        svg {
            g {
                circle {
                    fill: ${({ theme }) => theme.colors.grey2};
                    stroke: ${({ theme }) => theme.colors.grey2};
                }
                
                line {
                    stroke: ${({ theme }) => theme.colors.white};
                }
            }
        }
    }
    .stockModelCard-options--tooltipItemListLi {
        font-size: ${rem('12px')};
    }
    .cardOptionTooltipItem--tooltipItem__title {
        color: ${({ theme }) => theme.colors.blue2};  
    }
`;
